import React from 'react';

const ChatBubbleExclamation = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0_2245_29283"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="-1"
        y="-1"
        width="18"
        height="18"
      >
        <rect x="-0.5" y="-0.5" width="17" height="17" fill="#D9D9D9" stroke="#00952A" />
      </mask>
      <g mask="url(#mask0_2245_29283)">
        <path
          d="M2.81989 13.8868L4.20678 12.4999H13.333C13.8333 12.4999 14.2741 12.3159 14.6282 11.9618C14.9824 11.6077 15.1663 11.1669 15.1663 10.6666V2.66659C15.1663 2.16626 14.9824 1.7255 14.6282 1.37137C14.2741 1.01723 13.8333 0.833252 13.333 0.833252H2.66634C2.16601 0.833252 1.72525 1.01723 1.37112 1.37137C1.01699 1.7255 0.833008 2.16626 0.833008 2.66659V13.0499C0.833008 13.2769 0.885268 13.5038 1.01651 13.7046C1.14804 13.906 1.33519 14.0448 1.54438 14.1345C1.75375 14.2242 1.98476 14.2642 2.22265 14.2177C2.46018 14.1713 2.65914 14.0476 2.81989 13.8868Z"
          fill="#ED5656"
          stroke="#BA2323"
        />
        <path
          d="M8.04762 7.92862C7.89246 7.92862 7.7624 7.87614 7.65744 7.77118C7.55248 7.66622 7.5 7.53616 7.5 7.381V3.54762C7.5 3.39246 7.55248 3.2624 7.65744 3.15744C7.7624 3.05248 7.89246 3 8.04762 3C8.20279 3 8.33285 3.05248 8.43781 3.15744C8.54277 3.2624 8.59525 3.39246 8.59525 3.54762V7.381C8.59525 7.53616 8.54277 7.66622 8.43781 7.77118C8.33285 7.87614 8.20279 7.92862 8.04762 7.92862ZM8.04762 10.6667C7.89246 10.6667 7.7624 10.6143 7.65744 10.5093C7.55248 10.4043 7.5 10.2743 7.5 10.1191C7.5 9.96396 7.55248 9.8339 7.65744 9.72894C7.7624 9.62398 7.89246 9.5715 8.04762 9.5715C8.20279 9.5715 8.33285 9.62398 8.43781 9.72894C8.54277 9.8339 8.59525 9.96396 8.59525 10.1191C8.59525 10.2743 8.54277 10.4043 8.43781 10.5093C8.33285 10.6143 8.20279 10.6667 8.04762 10.6667Z"
          fill="white"
        />
      </g>
    </svg>
  );
};

export default ChatBubbleExclamation;
